<script>
import "./styles/website-layout.scss";
import "./styles/website-header.scss";
import "./styles/website-footer.scss";

import WebsiteFooter from "@/layouts/website/components/WF/WebsiteFooter.vue";
import WebsiteContainer from "@/layouts/website/components/WebsiteContainer.vue";
import WebsiteHeader from "@/layouts/website/components/WH/WebsiteHeader.vue";

export default {
  components: { WebsiteHeader, WebsiteContainer, WebsiteFooter },
  data() {
    return {};
  },
};
</script>

<template>
  <div class="website-layout">
    <WebsiteHeader />
    <WebsiteContainer />
    <WebsiteFooter />
  </div>
</template>
